import React from 'react';
import PropTypes from 'prop-types';
import { getPagePath, withLocales } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { localesShape } from '@spotahome/soyuz/shapes';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';
import { HeaderContainer as HeaderContainerComponent } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import '@spotahome/ui-library/lib/components/AccountNotValidatedBanner.css';
import '@spotahome/ui-library/lib/components/CloseButton.css';
import '@spotahome/ui-library/lib/components/Dropdown.css';
import '@spotahome/ui-library/lib/components/DropdownItem.css';
import '@spotahome/ui-library/lib/components/FacebookButton.css';
import '@spotahome/ui-library/lib/components/GoogleButton.css';
import '@spotahome/ui-library/lib/components/Header.css';
import '@spotahome/ui-library/lib/components/IconFacebook.css';
import '@spotahome/ui-library/lib/components/IconGoogle.css';
import '@spotahome/ui-library/lib/components/LanguageSwitcher.css';
import '@spotahome/ui-library/lib/components/LoginButton.css';
import '@spotahome/ui-library/lib/components/LoginLandlord.css';
import '@spotahome/ui-library/lib/components/LoginSignupModal.css';
import '@spotahome/ui-library/lib/components/LoginSignupModalActions.css';
import '@spotahome/ui-library/lib/components/MenuIcon.css';
import '@spotahome/ui-library/lib/components/MobileMenu/MobileMenu.css';
import '@spotahome/ui-library/lib/components/Modal.css';
import '@spotahome/ui-library/lib/components/ModalBody.css';
import '@spotahome/ui-library/lib/components/ModalFooter.css';
import '@spotahome/ui-library/lib/components/ModalHeader.css';
import '@spotahome/ui-library/lib/components/ModalWithImage.css';
import '@spotahome/ui-library/lib/components/OrTextLine/OrTextLine.css';
import '@spotahome/ui-library/lib/components/LoginSignupQuestion/LoginSignupQuestion.css';
import '@spotahome/ui-library/lib/components/SignUpLandlord.css';
import '@spotahome/ui-library/lib/components/SignUpLandlordForm.css';
import '@spotahome/ui-library/lib/components/SignUpLandlordFormGroup.css';
import '@spotahome/ui-library/lib/components/SignUpLandlordFormSuccessMessage.css';
import '@spotahome/ui-library/lib/components/Tab.css';
import '@spotahome/ui-library/lib/components/Tabs.css';
import '@spotahome/ui-library/lib/components/TabsLegacy.css';
import '@spotahome/ui-library/lib/components/TelephoneInput.css';
import '@spotahome/ui-library/lib/components/TermsAndConditionsNote.css';
import '@spotahome/ui-library/lib/components/Toast.css';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
} from '../api/traditional-login-client';

import { TOKEN_EXPIRED } from '../channels';
import './HeaderContainer.scss';

const SESSION_EXPIRED_STATUS = 401;

const traditionalSignupCB = (name, email, password) =>
  traditionalSignup({ name, email, password });

const traditionalLoginCB = (email, password) =>
  traditionalLogin({ email, password });

const traditionalForgotPasswordCB = async email => {
  try {
    await traditionalForgotPassword({ email });
  } catch (err) {
    console.log(err);
  }
};

async function requestLoggedInUserInfo() {
  try {
    const response = await getLoggedInUserInfo();
    return response;
  } catch (err) {
    if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
      Mediator.publish(TOKEN_EXPIRED);
      return null;
    }
    throw new Error(err);
  }
}
class HeaderContainer extends React.Component {
  static contextTypes = {
    server: PropTypes.shape({
      currentRoute: PropTypes.string
    }),
    request: PropTypes.shape({
      params: PropTypes.object
    })
  };

  onChangeLocale = locale => {
    Metrics.ga.sendEvent('i18n', 'language-switcher', locale);
    const queryString = window.location.search;
    const currentRoute = this.context.server.currentRoute;
    const params = this.context.request.params;

    window.location =
      getPagePath(currentRoute, { locale, params }) + queryString;
  };
  render = () => {
    const { locales, ...rest } = this.props;
    return (
      <HeaderContainerComponent
        className="header-menu-wrapper"
        color="light"
        locales={{
          current: locales.current,
          onChange: this.onChangeLocale
        }}
        login={{
          getLoggedInUserInfo: requestLoggedInUserInfo,
          modalProps: {
            traditionalSignupCB,
            traditionalLoginCB,
            forgotPasswordCB: traditionalForgotPasswordCB
          }
        }}
        links={{ changeCity: true }}
        {...rest}
      />
    );
  };
}

HeaderContainer.propTypes = {
  locales: PropTypes.shape(localesShape).isRequired
};

export default withLocales()(HeaderContainer);
